import React from 'react';
import { Link as MuiLink, Typography } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useTheme } from '@mui/material/styles';
import { useCompany } from '../context/CompanyProvider';

/**
 * External link to the company's public marketing website.
 * slot: "sidebar" | "login"
 */
const CompanyWebsiteLink = ({ slot = 'sidebar', sx = {} }) => {
  const { company } = useCompany();
  const theme = useTheme();
  const site = company.marketingSite;
  if (!site?.url) return null;

  const lightNav = Boolean(theme.fw?.lightNav);
  const tokens = theme.fw?.tokens || {};

  if (slot === 'login') {
    return (
      <MuiLink
        href={site.url}
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.5,
          fontSize: '0.875rem',
          fontWeight: 500,
          color: 'primary.main',
          ...sx,
        }}
      >
        {site.label}
        <OpenInNewIcon sx={{ fontSize: '0.95rem' }} />
      </MuiLink>
    );
  }

  return (
    <MuiLink
      href={site.url}
      target="_blank"
      rel="noopener noreferrer"
      underline="none"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 0.5,
        px: 1.25,
        py: 0.75,
        borderRadius: 1,
        fontSize: '0.72rem',
        fontWeight: 600,
        letterSpacing: 0.2,
        color: lightNav ? tokens.ink : 'rgba(215,227,239,0.88)',
        border: lightNav ? `1px solid ${tokens.line}` : '1px solid rgba(255,255,255,0.14)',
        backgroundColor: lightNav ? tokens.white : 'rgba(255,255,255,0.06)',
        transition: 'background-color 0.15s ease, color 0.15s ease',
        '&:hover': {
          backgroundColor: lightNav ? tokens.subtle : 'rgba(255,255,255,0.12)',
          color: lightNav ? tokens.muted : '#fff',
        },
        ...sx,
      }}
    >
      <Typography component="span" variant="caption" sx={{ fontWeight: 600, lineHeight: 1.2 }}>
        {site.label}
      </Typography>
      <OpenInNewIcon sx={{ fontSize: '0.85rem', opacity: 0.85 }} />
    </MuiLink>
  );
};

export default CompanyWebsiteLink;
